import React, { useState } from 'react';

const OPSEC_PALETTE = [
  { min: 1, max: 2, label: 'Safe', color: '#00ff88' },
  { min: 3, max: 4, label: 'Low Risk', color: '#f1fa8c' },
  { min: 5, max: 6, label: 'Medium', color: '#ffb86c' },
  { min: 7, max: 8, label: 'High Risk', color: '#ff6e6e' },
  { min: 9, max: 10, label: 'Critical', color: '#ff0000' },
];

const getOpsecInfo = (score) => {
  for (const entry of OPSEC_PALETTE) {
    if (score >= entry.min && score <= entry.max) return entry;
  }
  return { label: 'Unknown', color: '#888888' };
};

const OpsecBadge = ({ score, showLabel = false, size = 'sm' }) => {
  const [hover, setHover] = useState(false);
  const info = getOpsecInfo(score);

  const dotSize = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';

  return (
    <span
      className="relative inline-flex items-center gap-1 cursor-default"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <span
        className={`${dotSize} rounded-full inline-block flex-shrink-0`}
        style={{ backgroundColor: info.color, boxShadow: `0 0 6px ${info.color}44` }}
      />
      {showLabel && (
        <span className="text-xs" style={{ color: info.color }}>
          {score}
        </span>
      )}

      {/* Tooltip */}
      {hover && (
        <span
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2 py-1 rounded text-xs whitespace-nowrap z-50 border"
          style={{
            backgroundColor: '#1a1a2e',
            borderColor: info.color + '66',
            color: info.color,
          }}
        >
          OPSEC {score}/10 — {info.label}
        </span>
      )}
    </span>
  );
};

export default OpsecBadge;
